<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Press Release - List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="pressReleaseCreate"
                >Create</CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By Press Release Title"
                    @input="searchPressRelease($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="10"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-2"
                    @click="rowClickedDetail(data.item.press_release_id)"
                    >View</CButton
                  >
                  <CButton
                    color="warning"
                    class="mb-0 mr-0"
                    @click="rowClickedEdit(data.item.press_release_id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchPressRelease('', 'REFRESH')"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="searchPressRelease('', 'BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
              class="pagination-btn-next"
              @click="searchPressRelease('', 'NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "PressRelease",
  data() {
    return {
      items: [],
      fields: [
        { key: "press_release_id", label: "ID" },
        { key: "press_release_title", label: "Press Title" },
        { key: "press_release_url", label: "Press URL" },
        { key: "created_at", label: "Created At" },
        { key: "action", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchPressRelease("", "");
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "COMMUNITY" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    searchPressRelease(event, action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }

      axios
        .get(
          `${this.domain}/v1/press_release/data?page=${this.activePage}&per_page=100&q=${event}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
            this.items.forEach((element) => {
              element.created_at = moment(String(element.created_at)).format(
                "MM/DD/YYYY hh:mm A"
              );
            });
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    rowClickedDetail(item) {
      this.$router.push({ path: `/about-us/press-release/detail/${item}` });
    },
    rowClickedEdit(item) {
      this.$router.push({ path: `/about-us/press-release/edit/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    pressReleaseCreate() {
      this.$router.push({ path: `/about-us/press-release/create` });
    },
  },
};
</script>

<style scoped>
@import url("./PressRelease.css");
</style>
